<script>
import VueTagsInput from '@johmun/vue-tags-input'
import axios from 'axios'
import store from '@state/store'
import debounce from 'debounce'
import mapKeys from 'lodash/mapKeys'
import snakeCase from 'lodash/snakeCase'
import {
  EVENT_GUESTS_VALIDATIONS,
  NEW_GUEST_DATA,
  SCRIPTS,
} from '@events/constant'
import { validationMixin } from 'vuelidate'

export default {
  name: 'RegistrationForm',
  components: { VueTagsInput },
  mixins: [validationMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
    currentUserId: {
      type: Number,
      required: true,
    },
    formFields: {
      type: String,
      default: null,
    },
    currentRegData: {
      type: String,
      default: null,
    },
    currentGuestsRegData: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    isEditView: false,

    regFormModal: null,
    guestsOptions: [],
    formRenderOptions: {},
    formBuilder: null,

    currentRegDataValues: [],
    currentGuestsRegDataValues: [],

    guestsAutoincrement: 0,
    regexGuestsFieldName: /"name":"([a-z]+-\d+)"/g,
    regexGuestsFieldValue: /"value":"([\s\S]*)"/g,

    $: null,
    isLoaded: false,

    selectedGuestsCount: 0,
    guests: [],

    eventDisplayGuests: [],
    eventGuest: '',
    eventGuests: [],

    isLoading: false,
  }),
  validations: EVENT_GUESTS_VALIDATIONS,
  computed: {
    maxGuestsCount() {
      return (
        this.eventDetails.max_people -
        this.joinedUsersCount -
        (this.amIJoined ? 0 : 1)
      )
    },
    joinedUsersCount() {
      if (!this.eventDetails.joined_users)
        return this.eventDetails.joined_users_count

      const getGuestsCount = (acc, { pivot }) => acc + (pivot.guests_count || 0)
      const guestsCount = this.eventDetails.joined_users.reduce(
        getGuestsCount,
        0
      )

      return this.eventDetails.joined_users.length + guestsCount
    },
    amIJoined() {
      return (
        this.event.joinedUsers &&
        !!this.event.joinedUsers.find(({ id }) => id === this.currentUserId)
      )
    },
    eventDetails() {
      return this.formatPayload(snakeCase, this.event)
    },
    isFull() {
      const { max_people: maxPeople } = this.event
      return maxPeople <= this.joinedUsersCount
    },
  },
  created() {
    if (this.currentRegData) {
      this.isEditView = true
      this.initEditView()
    } else {
      this.setup()
      this.setGuestsOptions()
    }
  },
  methods: {
    formatPayload(formater, payload) {
      return mapKeys(payload, (value, key) => formater(key))
    },
    onEditClick() {
      this.isEditView = false
      this.setup()
      this.setGuestsOptions()
    },

    setup() {
      const self = this
      this.$loadScript(SCRIPTS.jQuery)
        .then(() => this.$loadScript(SCRIPTS.jQueryUI))
        .then(() => {
          self.$ = window.jQuery
          self.$(() => {
            self.$loadScript(SCRIPTS.formRender).then(() => {
              self.$(function() {
                self.renderForm()

                if (self.selectedGuestsCount) {
                  self.updateGuestsInputs()
                }
              })
            })
          })
        })
        .catch(() => {
          alert('error')
        })
    },

    initEditView() {
      if (!this.currentRegData) return

      const formData = JSON.parse(this.currentRegData)

      this.currentRegDataValues = formData
        .map((field) => {
          if (['header', 'paragraph', 'checkbox'].includes(field.type)) return

          let value = field.value

          // for select
          if (field.values) {
            field.values.map((option) => {
              if (option.value === value) {
                value = option.label
              }
            })
          }

          return {
            value,
            type: field.type,
            label: field.label,
          }
        })
        .filter((field) => !!field)

      this.currentGuestsRegDataValues = this.currentGuestsRegData.map(
        (guest, index) => {
          let fields = []
          if (typeof guest.pivot.registration_form_data === 'string') {
            fields = JSON.parse(guest.pivot.registration_form_data) || []
          } else {
            fields = guest.pivot.registration_form_data
          }

          this.currentGuestsRegData[index].pivot.registration_form_data = fields

          return fields
            .map((field) => {
              if (['header', 'paragraph', 'checkbox'].includes(field.type))
                return

              let value = field.value

              // for select
              if (field.values) {
                field.values.forEach(function(option) {
                  if (option.value === value) {
                    value = option.label
                  }
                })
              }

              return {
                value: value,
                label: field.label,
              }
            })
            .filter((field) => !!field)
        }
      )

      if (this.currentGuestsRegData.length) {
        this.selectedGuestsCount = this.currentGuestsRegData.length
        this.guests = this.currentGuestsRegData
      }
    },

    setGuestsOptions() {
      this.guestsOptions = []

      this.myMaxGuestsCount = Math.max(
        this.maxGuestsCount,
        this.eventDetails.guests.length
      )

      if (this.myMaxGuestsCount) {
        for (let i = 0; i <= this.myMaxGuestsCount; i++) {
          this.guestsOptions.push({ name: i || 'None', value: i })

          // if (this.guests && this.guests[i]) {
          //   this.guests[i] = this.guests[i]
          // } else {
          //   this.guests[i] = this.newGuestData
          // }
        }
      }

      // this.selectedGuestsCount = this.guestsCount
    },

    renderForm() {
      if (!this.formFields) return

      const self = this

      this.formRenderOptions = {
        formData: this.currentRegData || this.formFields,
        dataType: 'json',
        layoutTemplates: {
          // label: function(label, data) {
          //   var otherElements = null
          //   if (Array.isArray(label)) {
          //     otherElements = label.slice(1)
          //     label = label[0]
          //   }
          //   var className = 'fb-' + data.type + '-label'
          //   // cheeky styling
          //   return self
          //     .$('<label class="' + className + '"/>')
          //     .attr('for', data.id)
          //     .append(this.$.parseHTML(label), otherElements)
          // },
        },
      }

      this.$('.fb-form')
        .first()
        .formRender(self.formRenderOptions)
    },
    updateEventGuests(newGuests, index) {
      this.eventDisplayGuests = []
      this.eventGuests = []
      this.guests[index] = newGuests[0]
      this.guests = [...this.guests]
    },

    getEventGuests: debounce(async function getEventGuests(index) {
      if (!this.guests[index].name) return

      return axios
        .get(`/api/v1/user/startingWith/${this.guests[index].name}/companyId/0`)
        .then(({ data }) => {
          if (!data.length) return
          if (data instanceof Array) {
            data = data.filter((user) => {
              return user.id !== this.currentUserId
            })
            this.eventDisplayGuests = data.map(
              ({ id, name, email, phone, image_url: imageUrl }) => ({
                id,
                text: name,
                name,
                email,
                phone: phone || 0,
                image_url: imageUrl,
              })
            )
          }
        })
    }, 500),

    removeGuest(index) {
      if (!this.guests[index]) return

      this.guests.splice(index, 1)
      this.selectedGuestsCount--
    },

    updateGuestsInputs() {
      this.guests.splice(this.selectedGuestsCount)

      for (let i = 0; i <= this.selectedGuestsCount - 1; i++) {
        this.guests[i] = this.guests[i] || { ...NEW_GUEST_DATA }
      }

      if (this.selectedGuestsCount && this.eventDetails.has_registration_form) {
        this.$nextTick(() => {
          const self = this
          this.$('.fb-guest-form:empty').each(function(index) {
            self.guestsAutoincrement++
            let formData =
              self.guests[index].pivot.registration_form_data || self.formFields
            if (typeof formData !== 'string') {
              formData = JSON.stringify(formData)
            }
            formData = formData.replace(
              self.regexGuestsFieldName,
              '"name":"$1@' + self.guestsAutoincrement + '"'
            )
            self.$(this).formRender({
              ...self.formRenderOptions,
              formData,
            })
          })
        })
      }
    },
    onSaveClick() {
      this.isLoading = true

      let payload = {
        eventId: this.eventDetails.id,
        userId: this.currentUserId,
      }

      if (this.formFields && this.eventDetails.has_registration_form) {
        const isValid = document.getElementById('my-form').checkValidity()

        if (!isValid) {
          alert('Please fill all fields to continue!')
          this.isLoading = false
          return
        }

        if (this.selectedGuestsCount && this.eventDetails.has_guests_enabled) {
          this.isLoading = true
          const vuelidate = this.$v.guests

          vuelidate.$touch()
          // if its still pending or an error is returned do not submit
          if (vuelidate.$pending || vuelidate.$error) {
            this.isLoading = false
            return
          }
        }

        const guestsNow = this.guests.slice(0, this.selectedGuestsCount)
        let fieldsWithValues = null

        this.isLoading = true
        this.$.fn.serializeAllArray = function() {
          var obj = []

          this.$('input, select', this).each(function() {
            if (this.name !== '') {
              obj.push({ name: this.name, value: this.$(this).val() })
            }
          })
          return obj
        }

        const values = this.$('#my-form').serializeArray()
        let guestIndex = -1

        // save entire form with entered values so we can easily edit afterwards
        // this decouples this user registration data from event form, i.e. if the form is changed, the user's form remains the old one - controversial choice
        fieldsWithValues = JSON.parse(this.formFields)

        guestsNow.map((guest, i) => {
          if (guest.id === 0) {
            delete guestsNow[i].id
          }
          guestsNow[i].registration_form_data = JSON.parse(
            JSON.stringify(fieldsWithValues)
          )
        })

        let indexForValuesWithNames = -1
        let totalValuesWithNames = 0

        if (fieldsWithValues != null && fieldsWithValues.length > 0) {
          fieldsWithValues.map((field, indexValues) => {
            if (field.name) {
              totalValuesWithNames++
            }
          })

          fieldsWithValues.forEach(function(field, indexValues) {
            if (field.name) {
              indexForValuesWithNames++
            }
            guestIndex = -1
            field.value = null
            values.forEach(function(value, index) {
              const match = /@\d+$/.exec(value.name)
              if (match && field.name === value.name.substr(0, match.index)) {
                // guests
                if (index % totalValuesWithNames === indexForValuesWithNames) {
                  guestIndex++
                }
                guestsNow[guestIndex].registration_form_data[
                  indexValues
                ].value = value.value
              } else if (field.name === value.name) {
                field.value = value.value
              }
            })
          })
        }

        payload = {
          ...payload,
          guestsCount: this.selectedGuestsCount,
          guests: guestsNow,
          registrationFormData: fieldsWithValues,
          waitlist: !!(this.event.waitlist && this.isFull),
        }
      }

      if (
        this.selectedGuestsCount &&
        this.eventDetails.has_guests_enabled &&
        !this.eventDetails.has_registration_form
      ) {
        this.isLoading = true
        const vuelidate = this.$v.guests
        vuelidate.$touch()
        // if its still pending or an error is returned do not submit
        if (vuelidate.$pending || vuelidate.$error) {
          this.isLoading = false
          return
        }

        payload = {
          ...payload,
          guestsCount: this.guests.length,
          guests: this.guests.map((guest) => {
            const cleanGuest = { name: guest.name, email: guest.email }
            if (guest.id) cleanGuest.id = guest.id
            if (guest.phone) cleanGuest.phone = guest.phone
            return cleanGuest
          }),
          waitlist: !!(this.event.waitlist && this.isFull),
        }
      }
      store
        .dispatch('events/joinEventWithExtraData', payload)
        .then((response) => this.$emit('joined', response))
        .catch(() => alert('Something went wrong.'))
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <BaseModalWindow
    :modalcls="
      'w-full md:max-w-1.95xl bg-white rounded-xl mx-auto px-10 py-8 shadow-box relative z-40 left-0'
    "
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <h3
        class="flex items-center gap-4 pb-6 italic font-brandon text-blue-darker text-35xl"
      >
        <span v-if="!!!(event.waitlist && isFull)"
          >REGISTRATION CONFIRMATION</span
        >
        <span v-if="!!(event.waitlist && isFull)">WAITLIST CONFIRMATION</span>
        <button v-if="isEditView" class="hover:opacity-75" @click="onEditClick">
          <BaseIcon name="pen" :size="24" />
        </button>
      </h3>

      <form id="my-form" @submit.prevent="onSaveClick">
        <template v-if="eventDetails.has_registration_form">
          <div v-if="isEditView" class="flex flex-col gap-4">
            <div v-for="item in currentRegDataValues" :key="item.value">
              <h4 v-html="item.label" />
              <p v-text="item.value" />
            </div>
          </div>
          <div
            v-else
            class="fb-form"
            :class="{ 'fb-guest-form:edit': currentRegData }"
          />
        </template>

        <template
          v-if="!!eventDetails.has_guests_enabled && guestsOptions.length"
        >
          <div
            v-if="isEditView && currentGuestsRegDataValues.length"
            class="flex flex-col gap-4"
          >
            <hr class="mt-4 border-gray-light" />

            <h3>Guests ( {{ currentGuestsRegDataValues.length }} )</h3>
            <div
              v-for="(item, index) in currentGuestsRegDataValues"
              :key="item.value"
              class="p-4 border rounded border-gray-light"
            >
              <div class="flex items-center flex-1 space-x-4">
                <img
                  v-if="currentGuestsRegData[index].image_url"
                  :src="currentGuestsRegData[index].image_url"
                  class="inline-block w-8 h-8 rounded-full"
                  alt=""
                />
                <span
                  class="text-blue-darker text-sml"
                  v-text="currentGuestsRegData[index].name"
                />
              </div>
              <hr class="my-4 border-gray-light" />
              <div class="flex flex-col gap-4">
                <div v-for="{ label, value } in item" :key="label">
                  <h4 v-html="label" />
                  <p v-text="value" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div>
              <BaseSelectBox
                v-model.number="selectedGuestsCount"
                class="w-1/2"
                label="Guests"
                :options="guestsOptions"
                @change="updateGuestsInputs"
              />
            </div>

            <div v-for="(v, index) in $v.guests.$each.$iter" :key="index">
              <hr class="my-3 border-gray-light" />
              <div class="flex space-x-4">
                <div v-if="!v.id.$model" class="flex items-start space-x-4">
                  <VueTagsInput
                    v-model="v.name.$model"
                    class="w-full"
                    :tags="eventGuests"
                    :autocomplete-items="eventDisplayGuests"
                    :add-on-blur="false"
                    placeholder="Name"
                    :class="
                      v.name.$error
                        ? 'border-volunteer_red'
                        : 'border-gray-light focus:border-gray'
                    "
                    @input="getEventGuests(index)"
                    @tags-changed="
                      (newGuests) => updateEventGuests(newGuests, index)
                    "
                  />
                  <input
                    v-model="v.email.$model"
                    type="email"
                    placeholder="Email"
                    class="w-full border input"
                    :class="
                      v.email.$error
                        ? 'border-volunteer_red'
                        : 'border-gray-light focus:border-gray'
                    "
                  />
                  <input
                    v-model="v.phone.$model"
                    type="tel"
                    placeholder="Phone"
                    class="w-full border input"
                    :class="
                      v.phone.$error
                        ? 'border-volunteer_red'
                        : 'border-gray-light focus:border-gray'
                    "
                  />
                </div>
                <div v-else class="flex items-center flex-1 space-x-4">
                  <img
                    v-if="v.image_url.$model"
                    :src="v.image_url.$model"
                    class="inline-block w-8 h-8 rounded-full"
                    alt=""
                  />
                  <span
                    class="text-blue-darker text-sml"
                    v-text="v.name.$model"
                  />
                </div>
                <button @click="removeGuest(index)">
                  <BaseIcon name="close" />
                </button>
              </div>
              <div
                ref="fb-guest-form"
                class="fb-guest-form"
                :class="{ 'fb-guest-form:edit': currentRegData }"
              />
            </div>
          </div>
        </template>

        <div class="flex justify-end mt-6">
          <button
            v-if="!isEditView"
            class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
            :class="{ 'text-gray bg-gray': isLoading }"
            :disabled="isLoading"
            @click="onSaveClick"
            v-text="isLoading ? 'Saving...' : 'Save'"
          />
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
            @click="$emit('close')"
          >
            Cancel
          </button>
        </div>
      </form>
    </template>
  </BaseModalWindow>
</template>

<style lang="scss">
/* stylelint-disable */
.rendered-form {
  .formbuilder-checkbox.form-group {
    @apply flex flex-col;

    .checkbox {
      all: unset;
    }

    .formbuilder-checkbox {
      @apply flex items-center gap-3;
    }
  }

  p.agreement-control {
    @apply overflow-y-auto border border-gray rounded py-2 px-3 mb-4;

    max-height: 150px;
  }

  h3.agreement-control,
  .formbuilder-input-label,
  .formbuilder-checkbox-label,
  .formbuilder-select-label {
    @apply block mb-2;
  }

  .formbuilder-required {
    @apply ml-1;
  }
}

.fb-guest-form\:edit .rendered-form {
  .agreement-control,
  .formbuilder-checkbox {
    @apply hidden;
  }
}

.fb-guest-form:not(:empty) {
  @apply p-4 border border-gray-light mt-3 rounded;
}
/* stylelint-enable */
</style>
